import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

const ExcelExport = ({ excelData, fileName }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <>
      <button
        onClick={(e) => exportToExcel(fileName)}
        className="bg-emerald-500 px-3 py-1 text-white rounded shadow-lg active:bg-lightBlue-500"
      >
        <p>Export to Excel</p>
      </button>
    </>
  );
};

export default ExcelExport;
